import React from 'react';
import Modal from '@material-ui/core/Modal';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {withStyles} from "@material-ui/core/styles";


const styles = theme => ({
    spinner: {
        position: "fixed",
        top: "50%",
        left: "50%",
        outline: "none",
    }
})


function LoadingResults(props) {
    const { classes , showLoading} = props;

    return (
        <Modal
            open={showLoading}
        >
            <CircularProgress color="secondary" className={classes.spinner}  />
        </Modal>
    );
}

export default withStyles(styles)(LoadingResults);
